import { Button, Form, Select, DatePicker, Input } from 'antd';
import moment from 'moment';
import React, { useEffect, useCallback } from 'react';

const disabledFutureDates = (current) => current && current > moment().endOf('day');
const CustomerGridFilters = (props) => {
    const { RangePicker } = DatePicker;
    const [form] = Form.useForm()

    useEffect(() => {
        form.setFieldsValue(props?.filterValues);
        if (props?.onloadGrid) {
            props.onloadGrid();
        }
    }, [props?.filterValues])
    const handleChange = useCallback((field) => (value) => {
        const trimmedValues = {
            ...form.getFieldsValue(),
            [field]: value
        };
        props?.filterObj(trimmedValues);
    }, [props, form]);
    const handleSearch = useCallback((values) => {
        let trimSearchData = values?.freeSearch?.trim();
        const invalidSearchPattern = /^[^\p{L}\p{N}]+$/u;
        if (!trimSearchData || invalidSearchPattern.test(trimSearchData)) {
            form.setFieldsValue({ ...values, freeSearch: null });
            props?.filterObj({ ...values, freeSearch: null });
            return;
        }
        const trimmedValues = {
            ...values,
            freeSearch: trimSearchData
        };
        props?.filterObj(trimmedValues);
    }, [props]);
    return (
        <div className=''>
            <Form className="custom-filter-field"
                autoComplete="off"
                onFinish={handleSearch}
                form={form}>
                <div className='grid md:grid-cols-3 gap-4'>
                    {/* <Form.Item
                        name="Status"
                        className='!mb-0'
                    >
                        <Select
                            className=""
                            placeholder={`Select Status`}
                            defaultValue={"All"}
                            onChange={handleChange("Status")}
                        >
                            {props?.stateLu?.map((item) => (
                                <Option value={item?.name} key={item?.name}>{item?.name}</Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item name="dateRange" className='!mb-0'>
                        <RangePicker
                            format="DD-MM-YYYY"
                            onChange={handleChange("dateRange")}
                            disabledDate={disabledFutureDates}
                        />
                    </Form.Item> */}
                    <Form.Item
                        className='input-style !mb-0'
                        name="freeSearch"
                    >
                        <Input placeholder='Search by Name,Email,Phone number'
                            suffix={<Button className='!bg-transparent border-none p-0 !hover:bg-transparent focus:bg-transparent focus:shadow-none' htmlType='submit'><span className="icon md search cursor-pointer"></span></Button>}
                            className="coin-search-input" maxLength={50} />
                    </Form.Item>
                </div>
            </Form>
        </div>
    )
}
export default React.memo(CustomerGridFilters);